import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import * as globals from "app/resources/globals";

import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorGuias } from "./componentes/multiguias/index";
import { OcurreGuias } from "./componentes/guias/ocurreguias";
import { PagoEntregaOcurre } from "./componentes/pago/index";
import { EntregaOcurreModal } from "./componentes/firmar";
import { ContactosAutorizados } from "./componentes/autorizados/index";
import { AcusesList } from "./componentes/acuses/index";
import { EntregaOcurreList } from "./componentes/list";
interface Props {
    value: models.EntregaOcurreModel;
    onChange: (x: models.EntregaOcurreModel) => void
};

class EntregaOcurreNoRx extends React.PureComponent<Props> {
    loadFunction = kea.loadItemsFuncFromResource(() => [], resources.Guia.Get, x => x.Folio, x => true);
    folios = (props: Props) => props.value.Folios;
    guias = createSelectorRx(this.folios, folios => this.loadFunction({}, folios));

    modalManager = kea.createModalManager();

    onGuiasChange = (values: string[]) => {
        const x = this.props.value;
        this.props.onChange({ ...x, Folios: values });
    }

    onFiltroChange = (filtro: models.FiltroGuia) => {
        const x = this.props.value;
        this.props.onChange({ ...x, filtro: filtro });
    }

    onLimpiar = () => {
        this.props.onChange(models.ocurreModelInicial);
        globals.setState(x => ({ ...x, ocurre: models.ocurreModelInicial }));
    }

    onPagoChange = (pago: models.PagoRealizadoModel) => {
        const x = this.props.value;
        this.props.onChange({ ...x, PagoRealizado: pago });
    }

    onAceptarPago = async () => {
        const guias = this.props.value.Folios;
        const folios = guias.join(", ");
        const idFirmaRemota = await resources.FirmaRemota.Add("Entrega de las guias " + folios);
        const firmaOk = await this.modalManager.showModal(EntregaOcurreModal, { idFirma: idFirmaRemota, folios: guias }, undefined);
        if (firmaOk.result) {
            const model: models.EntregaOcurreModel = { ... this.props.value, IdFirmaRemota: idFirmaRemota };
            var idFactura = await resources.EntregaOcurre.RealizarEntrega(model);
            await kea.message("Entrega realizada correctamente", "Se registró la entrega correctamente", "success");
            //Reseteear la entrega ocurre
            this.props.onChange(models.ocurreModelInicial);
            //Si se generó una factura a partir de esta documentación se timbra
            if (idFactura != null) {
                var mensaje = await resources.Factura.TimbrarFacturaMensajeException(idFactura);
                if (mensaje != null)
                    await kea.message("Error en el timbrado de la factura", mensaje, "warning");
            }

        }
    }

    onTabChange = (x: number) => {
        this.props.onChange({ ... this.props.value, tab: x });
    }

    render() {
        const ocurre = this.props.value;
        const folios = ocurre.Folios;
        const guias = this.guias(this.props);
        const filtro = ocurre.filtro;
        const idCliente = filtro.IdClienteDestino;
        const pago = ocurre.PagoRealizado;

        return (
            <div>
                <kea.Title titulo="Entrega a ocurre" onLimpiar={this.onLimpiar} />
                <kea.Tab
                    items={[
                        { title: "Seleccionar guias", iconClass: fa("list-ol"), body: <MultiselectorGuias value={folios} filtro={filtro} onChange={this.onGuiasChange} onFiltroChange={this.onFiltroChange} /> },
                        { title: "Resumen de guías", iconClass: fa("files-o"), body: <OcurreGuias value={guias} />, quitar: true },
                        { title: "Contactos autorizados", iconClass: fa("user-o"), body: <ContactosAutorizados guias={guias} /> },
                        { title: "Acuses", iconClass: (fa("file-o")), body: <AcusesList guias={guias} /> },
                        { title: "Pago", iconClass: fa("money"), body: <PagoEntregaOcurre guias={guias} onChange={this.props.onChange} onAceptar={this.onAceptarPago} value={ocurre} /> },
                        { title: "Entregas realizadas", iconClass: fa("list-ol"), body: <EntregaOcurreList />, quitar: true }
                    ]}
                    value={this.props.value.tab}
                    onChange={this.onTabChange}
                />

                {this.modalManager.component}
            </div>
        );
    }
}

export const EntregaOcurre = kea.defaultProps(componentToRx(EntregaOcurreNoRx), {
    value: globals.state.map(x => x.ocurre),
    onChange: (x: models.EntregaOcurreModel) => globals.setState(old => ({ ...old, ocurre: x }))
});


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/pantalla.tsx